import { bottomMarginItemGlobal } from "../../utils/pdfConstants";

const GREEN = "#04aa00";
const LINE_COLOR = "#555555";

const INDEX_TABLES = [
  {
    title: "Indeksi seinän aluelämpötiloille",
    rows: [
      "97–100 % A kiitettävä",
      "93–96 % B erittäin hyvä",
      "89–92 % C hyvä",
      "85–88 % D tyydyttävä – lievästi riskialtis",
      "81–84 % E välttävä – riskialtis",
      "≤ 80 % F huono – erittäin riskialtis",
    ],
  },
  {
    title: "Indeksi lattian aluelämpötiloille",
    rows: [
      "100 % A kiitettävä",
      "99 % B erittäin hyvä",
      "97–98 % C hyvä",
      "95–96 % D tyydyttävä – lievästi riskialtis",
      "93–94 % E välttävä – riskialtis",
      "≤ 92 % F huono – erittäin riskialtis",
    ],
  },
  {
    title: "Indeksi pistemäisille vioille",
    rows: [
      "93–100 % A kiitettävä",
      "85–92 % B erittäin hyvä",
      "71–84 % C hyvä",
      "69–70 % D tyydyttävä – lievästi riskialtis",
      "61–68 % E välttävä – riskialtis",
      "≤ 61 % F huono – erittäin riskialtis",
    ],
  },
  {
    title:
      "Indeksi ikkunoiden, ovien ja läpivientien liitokset ja tiivistepinnat",
    rows: [
      "86–100 % A kiitettävä",
      "80–85 % B erittäin hyvä",
      "74–79 % C hyvä",
      "68–73 % D tyydyttävä – lievästi riskialtis",
      "62–67 % E välttävä – riskialtis",
      "≤ 61 % F huono – erittäin riskialtis",
    ],
  },
];

function createIndexTable(table) {
  return {
    table: {
      widths: ["*"],
      body: [
        // Green header
        [
          {
            text: table.title,
            bold: true,
            color: "#ffffff",
            fillColor: GREEN,
            font: "Lato",
            fontSize: 9,
            margin: [5, 3, 5, 3],
          },
        ],

        // Data rows
        ...table.rows.map((row) => [
          {
            text: row,
            bold: true,
            font: "Lato",
            fontSize: 8,
            margin: [5, 1, 5, 1],
          },
        ]),
      ],
    },

    layout: {
      // Horizontal lines only
      hLineWidth: (i) => {
        // no line above green header
        if (i === 0) return 0;

        return 0.7;
      },

      hLineColor: () => LINE_COLOR,

      // No vertical lines
      vLineWidth: () => 0,

      paddingLeft: () => 0,
      paddingRight: () => 0,
      paddingTop: () => 0,
      paddingBottom: () => 0,
    },
  };
}

export function renderLampotilaIndeksiBlock({
  data,
  content,
  contentWidth,
}) {
  if (!content) return;

  const gap = 10;

  const availableWidth = contentWidth || 500;
  const columnWidth = (availableWidth - gap) / 2;

  const topLeft = createIndexTable(INDEX_TABLES[0]);
  const topRight = createIndexTable(INDEX_TABLES[1]);
  const bottomLeft = createIndexTable(INDEX_TABLES[2]);
  const bottomRight = createIndexTable(INDEX_TABLES[3]);

  content.push({
    stack: [
      // TOP ROW
      {
        columns: [
          {
            width: columnWidth,
            stack: [topLeft],
          },
          {
            width: columnWidth,
            stack: [topRight],
          },
        ],
        columnGap: gap,
      },

      // Space between top and bottom tables
      {
        text: "",
        margin: [0, 3, 0, 3],
      },

      // BOTTOM ROW
      {
        columns: [
          {
            width: columnWidth,
            stack: [bottomLeft],
          },
          {
            width: columnWidth,
            stack: [bottomRight],
          },
        ],
        columnGap: gap,
      },
    ],

    margin: [0, 0, 0, bottomMarginItemGlobal],
    unbreakable: true,
  });
}